/* prettier-ignore-file */
import React, { useState, useEffect } from "react";
import { View, Text, StyleSheet, ActivityIndicator } from "react-native";
import { useParams, useSearchParams } from "react-router-dom";
import { db } from "../firebase.config";
import { doc, getDoc } from "firebase/firestore";
import ThirdPartyWaiver from "../components/ThirdPartyWaiver";
import { getSettingsPath } from "../utils/dbPaths";

const TransferWaiverPage = () => {
  const { bookingId } = useParams();
  const [searchParams] = useSearchParams();
  const transferEmail = searchParams.get("email");
  
  const [loading, setLoading] = useState(true);
  const [legalStoreName, setLegalStoreName] = useState("");
  const [legalStoreAddress, setLegalStoreAddress] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        console.log("📋 Loading transfer waiver for booking:", bookingId);
        console.log("📧 Transfer email:", transferEmail);

        // Load legal store name and address from settings
        const settingsPath = getSettingsPath() || "tenants/1234/stores/999/settings";
        
        const nameDoc = await getDoc(doc(db, settingsPath, "legalStoreName"));
        if (nameDoc.exists()) {
          setLegalStoreName(nameDoc.data().name || "Legal Store Name");
        } else {
          setLegalStoreName("Legal Store Name");
        }

        const addressDoc = await getDoc(doc(db, settingsPath, "legalStoreAddress"));
        if (addressDoc.exists()) {
          setLegalStoreAddress(addressDoc.data().address || "");
        }

        setLoading(false);
      } catch (error) {
        console.error("❌ Error loading transfer waiver data:", error);
        setError(error.message);
        setLoading(false);
      }
    };

    loadData();
  }, [bookingId, transferEmail]);

  if (loading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#0E7C6B" />
        <Text style={styles.loadingText}>Loading waiver...</Text>
      </View>
    );
  }

  if (error) {
    return (
      <View style={styles.errorContainer}>
        <Text style={styles.errorText}>❌ Error loading waiver</Text>
        <Text style={styles.errorSubtext}>{error}</Text>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <ThirdPartyWaiver
        legalStoreName={legalStoreName}
        legalStoreAddress={legalStoreAddress}
        bookingId={bookingId}
        transferEmail={transferEmail}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F6F8F7",
  },
  loadingContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#F6F8F7",
  },
  loadingText: {
    marginTop: 10,
    fontSize: 16,
    color: "#5C6B68",
  },
  errorContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    backgroundColor: "#F6F8F7",
  },
  errorText: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#C4453D",
    marginBottom: 10,
  },
  errorSubtext: {
    fontSize: 14,
    color: "#5C6B68",
    textAlign: "center",
  },
});

export default TransferWaiverPage;

